/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_DoneInputs */

const en_us2_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

const pt_br2_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const es_419_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const pt_pt2_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluído`)
};

const fr_fr2_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

const de_de2_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig`)
};

const it_it2_history_transfer_done = /** @type {(inputs: History_Transfer_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {History_Transfer_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_done = /** @type {((inputs?: History_Transfer_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_done(inputs)
	if (locale === "es-419") return es_419_history_transfer_done(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_done(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_done(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_done(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_done(inputs)
	return en_us2_history_transfer_done(inputs)
});
export { history_transfer_done as "history-transfer.done" }